import React from "react";

export default function HallOfFameDuck(props: any) {
    return (
        <div className='flexColumn' style={{gap: '5px'}}>
            {props.placing === 1 && (
                <div className='flexRow' style={{fontSize: '20px', fontWeight: 'bold'}}>
                    <div>1st Place</div>
                    <img alt='trophy' style={{height: '32px', marginTop: '10px'}} src='trophy-gold.png'/>
                </div>
            )}
            {props.placing === 2 && (
                <div className='flexRow' style={{fontSize: '20px', fontWeight: 'bold'}}>
                    <div>2nd Place</div>
                    <img alt='trophy' style={{height: '32px', marginTop: '10px'}} src='trophy-silver.png'/>
                </div>
            )}
            {props.placing === 3 && (
                <div className='flexRow' style={{fontSize: '20px', fontWeight: 'bold'}}>
                    <div>3rd Place</div>
                    <img alt='trophy' style={{height: '32px', marginTop: '10px'}} src='trophy-bronze.png'/>
                </div>
            )}
            <div><img alt='duck' height='175px' width='175px' src={'https://nft-images.netlify.app/ApexDucks/image-' + props.nft + '-250.png'} /></div>
            <div style={{fontSize: '20px'}}>ApexDucks #{props.nft}</div>
            <div className='flexRow' style={{gap: '10px'}}>
                <div style={{fontSize: '20px', fontWeight: 'bold'}}>{props.title}</div>
                <img alt='' title={'revshare ' + props.revshare + ' SOL'} src='solcoin.png' style={{marginTop: '5px', height: '24px'}}/>
            </div>
            <div className='flexRow' style={{gap: '10px'}}>
                <div style={{fontSize: '18px', fontWeight: 'bold'}}>{props.wins} wins</div>
                <img alt='' src='duck-icon-small.png' style={{marginTop: '5px', height: '20px'}}/>
            </div>
        </div>
    );
}
